export const locale = {
    lang: 'de',
    data: {
        CHANGE_DOCUMENT_DIALOG: {
            TITLE: 'Copy the document',
            FORM: {
                TITLE: 'Filename',
                SAVE: 'Speichern'
            },
            NOTIFICATIONS: {
                SAVINGITEM: 'i18n',
                SAVING: 'CHANGE',
                WAIT: 'Bitte warten.',
                SUCCESS: 'File being successfully copied',
                DUPLICATE: 'File with such name already exists',
                ERROR: 'Error occurred during copying of the file',
                INVALID_CHARACTERS: 'Ungültige Sonderzeichen im Dateinamen'
            },
        }
    },
};
